import React from "react";
import BlogSidebar from "./BlogSidebar";
import BlogCardComponent from "./BlogCardComponent";

const BlogContainer = React.memo((props: any) => {
  return (
    <div className="flex flex-col lg:flex-row justify-center max-w-7xl bg-white mx-auto px-6 xl:px-0 mb-16">
      <div className="flex lg:w-3/12 w-full mt-16">
        <BlogSidebar
          setBlogByCat={props.setBlogByCat}
          blogByCat={props.blogByCat}
          loading={props.loading}
          setLoading={props.setLoading}
          allPostsBySearch={props.allPostsBySearch}
          allCategories={props.allCategories}
        />
      </div>
      <div className="flex flex-col w-9/12 w-full justify-center items-center mx-auto lg:pl-10  mt-16">
        <div className="grid grid-cols-2 gap-x-0 gap-y-5 md:gap-x-20 md:gap-y-10 justify-center w-full">
          {props.allPosts?.length > 0 ? (
            props.allPosts?.map((obj: any, index: any) => {
              return (
                <BlogCardComponent
                  data={obj.attributes}
                  image={obj.attributes?.image?.data?.attributes?.url}
                  key={index}
                  index={index}
                  latest={false}
                />
              );
            })
          ) : (
            <div className="col-span-2 w-full flex flex-col items-center justify-center text-3xl font-bold">
              {props.loading ? (
                <>
                  <div className="h-14 w-14 border-blue-100 animate-spin rounded-full border-8 border-r-blue-600 "></div>
                </>
              ) : (
                <div className="col-span-2 w-full flex flex-col items-center justify-center text-3xl font-bold">
                  <h1>No Article found in This category</h1>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default BlogContainer;
